export default __webpack_public_path__ + "static/media/Beehaz_05_ical.1286f3dc.png";